import {
  shortCodeAcquire,
  textPurpose,
  textService,
} from "../../OtherValueAdded/MobileTextMessage";

const MobileTextMessagesServiceOverview = ({ data }) => {
  const {
    ov_mtm_service_code = "",
    ov_mtm_service_short_code = "",
    ov_mtm_service_use = "",
  } = data["6_6"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="review-summary-sub-heading">
        <div i2c-grid="12@md">
          <div className="fw-700 font-bold">
            Mobile Text Messaging Service (mRay)
          </div>
          <div className="overview-help-text-for-heading font-bold">
            For text message service, would you like to use i2c short code?
          </div>
          <div className="overview-val-text">
            {textService.find((ser) => ser.value === ov_mtm_service_code)
              ?.label ?? "-"}
          </div>
        </div>

        {ov_mtm_service_code === "dedicated-short-code" ? (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              Acquire short code for text messaging:
            </div>
            <div className="overview-val-text">
              {shortCodeAcquire.find(
                (ser) => ser.value === ov_mtm_service_short_code,
              )?.label ?? "-"}
            </div>
          </div>
        ) : null}

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Text messaging will be used to:
          </div>
          <div className="overview-val-text">
            {textPurpose.find((ser) => ser.value === ov_mtm_service_use)
              ?.label ?? "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default MobileTextMessagesServiceOverview;
